<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원공지사항</span>
            <span class="txt">회원들에게 공지사항, 업데이트 등 여러 사항을 전달할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button v-if="isWriteAuth" class="com-setting-btn" @click="categoryPop = true"></button>
                </div>
                <div class="right-box">
                    <!--                    <router-link to="/madmin/setting/member/notice/list" class="com-btn gray">목록</router-link>-->
                    <!--                    <button class="com-btn blue" @click="onClickRegist" v-if="!isModify && isWriteAuth">등록</button>-->
                    <!--                    <button class="com-btn blue" @click="onClickModify" v-else-if="isWriteAuth">수정</button>-->
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td class="no-padding">
                            <select-form
                                :select-data="['카테고리를 선택하세요.', ...categoryTypeList]"
                                :select-value="['', ...categoryTypeValueList]"
                                :selected-value="categoryId"
                                class="full"
                                @update:set="(val) => (categoryId = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td>
                            <input v-model="editField.title" class="w100p" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>내용</th>
                        <td>
                            <ckeditor v-model="editField.content" :config="editorConfig" :editor="editor"></ckeditor>
                        </td>
                    </tr>
                    <tr>
                        <th>파일 첨부</th>
                        <td class="no-padding">
                            <div class="file-box">
                                <input
                                    v-model="fileNameListStr"
                                    class="design-input"
                                    readonly
                                    type="text"
                                    value="파일명.jpg"
                                />
                                <b-form-file
                                    id="file1"
                                    accept=".jpg, .png, .gif"
                                    plain
                                    @change="handleFile"
                                ></b-form-file>
                                <label for="file1">찾아보기</label>
                            </div>
                            <p class="file-info">
                                ※ 이미지는 660px*660px 정사각형 사이즈와 최대 100MB 용량으로 최적화되어 있습니다.
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="table-bottom-check">
                <div class="com-check">
                    <input id="check-1-1" v-model="editField.topFixYn" name="check-1" type="checkbox" />
                    <label for="check-1-1">이 글을 상단에 고정합니다.</label>
                </div>
            </div>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/setting/member/notice/list">목록</router-link>
                    <button v-if="!isModify && isWriteAuth" class="com-btn blue" @click="onClickRegist">등록</button>
                    <button v-else-if="isWriteAuth" class="com-btn blue" @click="onClickModify">수정</button>
                </div>
            </div>
        </div>

        <!-- 설정 팝업 -->
        <div v-show="categoryPop" class="layer-pop category-setting">
            <div class="view-content">
                <button class="close" @click="categoryPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 설정</span>
                    <p class="sub-txt">
                        카테고리의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        카테고리 삭제 시, 이전에 작성된 해당 카테고리의 게시글은 카테고리가 없이 표시됩니다.
                    </p>
                    <loading-spinner v-if="isLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div
                                v-for="(category, index) in categoryList.infos"
                                v-if="category.deleteYn === false"
                                class="line"
                            >
                                <input :key="index" ref="categoryArray" v-model="category.name" type="text" />
                                <button class="com-btn" @click="onClickDeleteCategory(category.id, index)">삭제</button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="onClickAddCategory">+추가</button>
                            </div>
                            <p class="txt">
                                <span class="imp">*</span>
                                최대 10개까지 추가 가능합니다.
                            </p>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCancle">취소</button>
                        <button v-if="isWriteAuth" class="com-btn blue" @click="onClickSaveCategory">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateSpace } from '@/assets/js/validation.js';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor.js';
import SimpleUpload from '../../../assets/js/ckeditor/simpleUpload';

export default {
    name: 'SettingMemberNoticeEdit',
    components: { LoadingSpinner },
    computed: {
        isModify() {
            return this.noticeId != null;
        },
        isWriteAuth() {
            const { getters } = this.$store;
            return (
                getters['auth/isCareAdmin'] ||
                getters['auth/isSystemAdmin'] ||
                getters['auth/isCenterAdmin'] ||
                getters['auth/isCenterStaff']
            );
        },
        isReadAuth() {
            const { getters } = this.$store;
            return this.isWriteAuth || getters['auth/isCustomer'];
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        staffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    mounted() {
        this.centerId = this.cId; // 회원 공지사항 centerId
        this.fetchCategory();
        if (this.isModify) {
            // 수정이면 공지사항 상세 가져옴
            this.fetchNoticeDetail();
        }
        if (this.$route.params.id !== undefined) {
            this.noticeId = this.$route.params.id;
        }
    },
    data() {
        return {
            categoryPop: false,
            centerId: null, // 회원 공지사항 centerId
            isLoading: false,
            noticeId: this.$route.params.id, // 공지사항 게시글 id가 있으면 수정
            categoryList: {
                infos: [],
            },
            categoryTypeList: [],
            categoryTypeValueList: [],
            noticeDetail: {},
            // showTypeList: ['전체 <small>(관리자 PC, 관리자 APP, 회원 APP 공지사항에 노출됩니다.)</small>', '관리자 <small>(관리자 PC, 관리자 APP 공지사항에 노출됩니다.)</small>', '회원 <small>(회원 APP 공지사항에 노출됩니다.)</small>'], // 노출대상
            // showTypeValueList: ['T', 'A', 'C'], // 노출대상 Value 목록
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },
            categoryId: '',
            editField: {
                title: '',
                content: '',
                topFixYn: false,
                deleteFileIds: [], // 삭제되는 첨부파일 fileId 배열
                uploadFiles: [],
            },

            // showType: '',

            base64data: '', // 업로드 파일 base64 임시 저장
            fetchFileList: [], // 수정화면에서 기존에 첨부되어 있던 파일 목록
            fileNameList: [], // 새로 업로드할 파일 목록을 이름으로만 배열로 관리
            fileNameListStr: '', // fileNameList 배열을 화면에 뿌릴때  ', ' 로 연결하기 위해 만든 순수 String

            selectedCategoryId: '',
            // selectedShowType: '',
        };
    },

    methods: {
        // 공지사항 상세 API
        sendGetNoticeDetail() {
            return api.get(`/admin/api/center/${this.centerId}/board/notice/${this.noticeId}`);
        },

        // 공지사항 상세 첨부 파일 리스트 API
        sendGetNoticeDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 공지사항 상세 Fetch
        async fetchNoticeDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetNoticeDetail();
                this.noticeDetail = data;

                const { editField, noticeDetail } = this;
                this.categoryId = String(noticeDetail.categoryId === null ? '' : noticeDetail.categoryId);
                editField.title = noticeDetail.title;
                editField.topFixYn = noticeDetail.topFixYn;
                editField.content = noticeDetail.content;

                if (noticeDetail.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.sendGetNoticeDetailFileGroup(noticeDetail.fileGroupId);
                    console.log(fileGroupData);
                    fileGroupData.data.forEach((file) => {
                        this.fileNameList.push(file.name);
                    });
                    this.fileNameListStr = this.fileNameList.join(', ');
                    this.fetchFileList = fileGroupData.data;
                }

                console.log('Success Loading Center Notice Detail', data);
                this.isLoading = false;
            } catch (error) {
                console.log(error.response.data);
            }
        },

        // 공지사항 등록 API
        sendPostNotice(data) {
            const params = this.getRegistParams();
            console.log('입력', params);
            return api.post(`/admin/api/center/${this.centerId}/board/notice`, {
                ...params,
            });
        },

        // 공지사항 수정 API
        sendPutNotice() {
            const params = this.getModifyParams();
            return api.put(`/admin/api/center/${this.centerId}/board/notice/${this.noticeId}`, {
                ...params,
            });
        },

        // 등록, 수정 validation
        validateValues() {
            const { title } = this.editField;

            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            const content = editorInstance.getData();
            if (title === '' || title === null) {
                this.$nextTick(function () {
                    this.$refs.refTitle.focus();
                });
                return '제목을 입력하세요.';
            } else if (content === '' || content === null) {
                return '내용을 입력하세요.';
            }
        },

        // 공지사항 등록 파라미터 가공
        getRegistParams() {
            const { title, topFixYn, uploadFiles } = this.editField;

            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            const content = editorInstance.getData();

            const categoryId = this.categoryId;
            const showType = 'C'; // 회원앱 = C
            const params = {
                categoryId,
                title,
                content,
                topFixYn,
                showType,
                uploadFiles,
                staffId: this.staffId,
            };
            if (uploadFiles.length === 0) {
                delete params.uploadFiles;
            }

            if (categoryId === '') {
                delete params.categoryId;
            }

            return params;
        },

        // 공지사항 수정 파라미터 가공
        getModifyParams() {
            const { title, topFixYn, uploadFiles, deleteFileIds } = this.editField;
            const categoryId = this.categoryId;
            const showType = 'C'; // 회원앱 = C

            if (uploadFiles.length !== 0) {
                // uploadFiles에 값이 있으면 파일을 수정한것, 기존 파일은 delete 배열에 넣음
                this.fetchFileList.forEach((file) => {
                    deleteFileIds.push(parseInt(file.fileId));
                });
            }

            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            const content = editorInstance.getData();

            const params = {
                categoryId,
                title,
                content,
                topFixYn,
                uploadFiles,
                deleteFileIds,
                staffId: this.staffId,
            };

            if (uploadFiles.length === 0) {
                delete params.uploadFiles;
            }

            if (categoryId === '') {
                delete params.categoryId;
            }

            return params;
        },

        // 공지사항 등록
        async onClickRegist() {
            const validate = this.validateValues();
            if (validate) {
                alert(validate);
                return;
            }
            this.isLoading = true;
            try {
                const { data } = await this.sendPostNotice();
                alert('등록 되었습니다.');
                console.log('===> Success Create Center Notice : ', data);
                this.$router.push({ name: 'SettingMemberNoticeList' });
            } catch (error) {
                alert('등록 실패했습니다.');
                console.log(error);
            }
            this.isLoading = false;
        },

        // 수정 버튼 클릭시
        async onClickModify() {
            const validate = this.validateValues();
            if (validate) {
                alert(validate);
                return;
            }
            try {
                this.isLoading = true;
                const { data } = await this.sendPutNotice();
                alert('수정 되었습니다.');
                console.log('===> Success Create Center Notice : ', data);
                this.isLoading = false;
                this.$router.push({ name: 'SettingMemberNoticeList' });
            } catch (error) {
                alert('수정 실패했습니다.');
                console.log(error);
            }
        },

        // File 핸들러
        async handleFile(e) {
            try {
                console.log(e);
                const file = e.target.files[0];
                let base64data = await this.readFileAsync(file);
                base64data = base64data.split(',')[1];
                if (base64data === undefined) {
                    alert('비어있는 파일은 첨부할 수 없습니다.');
                    return;
                }
                const fileInfo = {
                    filename: file.name,
                    mimetype: file.type,
                    base64data,
                };

                if (this.noticeId) {
                    if (this.editField.uploadFiles.length === 0) {
                        this.fileNameList = [];
                        this.fileNameList.push(fileInfo.filename);
                        this.fileNameListStr = this.fileNameList.join(', ');
                    } else {
                        this.fileNameList.push(fileInfo.filename);
                        this.fileNameListStr = this.fileNameList.join(', ');
                    }
                } else {
                    this.fileNameList.push(fileInfo.filename);
                    this.fileNameListStr = this.fileNameList.join(', ');
                }
                this.editField.uploadFiles.push(fileInfo);
            } catch (error) {
                console.log(error);
                alert('파일 첨부 중 오류가 발생했습니다.');
            }
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        // 카테고리 가져오기
        async fetchCategory() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetCategoryList();
                console.log('===> Success Loading categoryList : ', data);
                data.forEach((category) => {
                    // 받아온 data의 key 값을 필요한 값으로만 재배열
                    const tempCategory = {
                        id: category.b_id,
                        largeType: category.b_l_type_cd,
                        smallType: category.b_s_type_cd,
                        name: category.b_namee,
                        deleteYn: category.b_del_yn,
                    };
                    this.categoryList.infos.push(tempCategory);
                });
                this.categoryList.infos.forEach((category) => {
                    // 카테고리 리스트를 select-form 카테고리 목록에 push
                    this.categoryTypeList.push(category.name);
                    this.categoryTypeValueList.push(String(category.id));
                });
                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },

        // 카테고리 목록 조회 API
        sendGetCategoryList() {
            return api.get('/admin/api/board/category', {
                params: {
                    largeType: 'C', // 케어어드민 : F, 센터어드민 : C
                    smallType: 'B', // 팝업 : P, 게시판 : B, 자주하는질문 : F, 일대일문의 : I, 메뉴얼 : M
                },
            });
        },

        // 카테고리 추가 버튼 클릭시
        onClickAddCategory() {
            if (this.categoryList.infos.length > 10) {
                alert('카테고리는 최대 10개까지만 추가 가능합니다.');
                return;
            }
            this.categoryList.infos.push({
                largeType: 'C', // 케어어드민 : F, 센터어드민 : C
                smallType: 'B', // 팝업 : P, 게시판 : B, 자주하는질문 : F, 일대일문의 : I, 메뉴얼 : M
                name: '',
                deleteYn: false,
            });
        },

        // 카테고리 삭제 버튼 클릭시
        onClickDeleteCategory(categoryId, index) {
            console.log(categoryId, index);
            if (categoryId === undefined) {
                this.categoryList.infos.splice(index, 1);
            } else if (categoryId) {
                this.categoryList.infos[index].deleteYn = !this.categoryList.infos[index].deleteYn;
            }
        },

        // 카테고리 저장 API
        sendPostSaveCatetory() {
            return api.post('/admin/api/board/category', this.categoryList);
        },

        // 카테고리 저장 버튼 클릭시
        async onClickSaveCategory() {
            const validate = this.validateCategoryValues();
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.categoryArray[validate.resultIndex].focus();
                });
                return;
            }
            try {
                const { data } = await this.sendPostSaveCatetory();
                console.log('===> Success Category create : ', data);
                alert('카테고리를 저장했습니다.');
                this.initCategoryValue();
                await this.fetchCategory();
            } catch (error) {
                alert('카테고리 저장 실패했습니다.');
                console.log(error);
            }
        },

        // 카테고리 validation
        validateCategoryValues() {
            const msg = '카테고리명을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.categoryArray.some((category, index) => {
                if (!validateSpace(category.value) || category.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return { result, resultIndex, msg };
        },

        // 취소 버튼 클릭시
        onClickCancle() {
            this.initCategoryValue();
            this.fetchCategory();
            this.categoryId = this.selectedCategoryId;
        },

        // 카테고리 저장전 관련 변수 초기화
        initCategoryValue() {
            this.categoryPop = false;
            this.categoryList = { infos: [] };
            this.categoryTypeList = [];
            this.categoryTypeValueList = [];
            this.selectedCategoryId = this.categoryId; // 이전에 선택했던 카테고리 임시 저장
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'image/png' });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.ui-select.full.on {
    // ckeditor가 select-form보다 위에 나타나는 이슈
    z-index: 10;
}

.ck-editor__editable {
    // ckeditor height 설정
    min-height: 500px;
}

a.file-down::after {
    // 첨부 파일 이름 텍스트
    content: ',' attr(file-down);
    margin-right: 5px;
}

a.file-down:last-of-type::after {
    // 첨부 파일 이름 텍스트
    content: '';
}
</style>
